import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HubPageLayout from '../components/HubPageLayout';
import FramedPanel from '../components/FramedPanel';
import MANIPULATION_TACTICS from './data/manipulationTactics';

// The Abuse Playbook — the manipulation tactics the Social Media IQ scams run
// on. Its own page (10-01), reached from the sidebar under Social Media IQ and
// from the link at the foot of that page; it used to sit below the matrix.

const ABUSE_PLAYBOOK_ICON = '/images/social-media-iq/abuse-playbook-icon.png';

const AbusePlaybookMark = () => {
  const [iconOk, setIconOk] = useState(true);
  return (
    <div className="flex items-center justify-center gap-10 pb-8">
      <span className="text-3xl xl:text-4xl font-bold text-black">Abuse</span>
      {iconOk && (
        <img
          src={ABUSE_PLAYBOOK_ICON}
          alt=""
          onError={() => setIconOk(false)}
          className="w-[150px] h-[150px] object-contain flex-shrink-0"
        />
      )}
      <span className="text-3xl xl:text-4xl font-bold text-black">Playbook</span>
    </div>
  );
};

const AbusePlaybookPage = () => (
  <HubPageLayout>
    {/* Same framed hero as Fraud Alerts: title on the frame, lockup inside. */}
    <FramedPanel title="The Abuse Playbook">
      <div className="px-6 pt-12 pb-4">
        <AbusePlaybookMark />
      </div>
    </FramedPanel>

    <div className="mt-8">
      <p className="text-sm text-gray-600 mb-4">
        {MANIPULATION_TACTICS.length} manipulation tactics scammers run on their targets.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {MANIPULATION_TACTICS.map((t) => (
          <div key={t.number} className="bg-[#FAFBFC] border border-gray-200 rounded p-5">
            <h3 className="text-sm font-bold text-black mb-2">
              {t.number} {t.title}
            </h3>
            <p className="text-xs text-gray-600 leading-relaxed">{t.description}</p>
          </div>
        ))}
      </div>

      <p className="mt-10 text-base text-black">
        See where these tactics show up:{' '}
        <Link to="/dashboard/social-media-iq" className="text-blue-600 hover:underline">
          Social Media IQ &rarr;
        </Link>
      </p>
    </div>
  </HubPageLayout>
);

export default AbusePlaybookPage;
